import { application } from "./application"

import NavToggleController from "./nav_toggle_controller"
application.register("nav-toggle", NavToggleController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import ListNoteController from "./list_note_controller"
application.register("list-note", ListNoteController)

import ListGroupController from "./list_group_controller"
application.register("list-group", ListGroupController)

import ListAddPlantController from "./list_add_plant_controller"
application.register("list-add-plant", ListAddPlantController)

// B4 - Plant management
import PlantAddToListController from "./plant_add_to_list_controller"
application.register("plant-add-to-list", PlantAddToListController)

import PlantFavoriteController from "./plant_favorite_controller"
application.register("plant-favorite", PlantFavoriteController)

import PlantNameController from "./plant_name_controller"
application.register("plant-name", PlantNameController)

import PlantDataAttributesController from "./plant_data_attributes_controller"
application.register("plant-data-attributes", PlantDataAttributesController)

import PlantLinksController from "./plant_links_controller"
application.register("plant-links", PlantLinksController)

import PlantSelectorController from "./plant_selector_controller"
application.register("plant-selector", PlantSelectorController)

// B5 - Search
import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

// B6 - Marketplace
import MarketplaceMapController from "./marketplace_map_controller"
application.register("marketplace-map", MarketplaceMapController)

import MarketplaceTradeController from "./marketplace_trade_controller"
application.register("marketplace-trade", MarketplaceTradeController)

import LocationFieldController from "./location_field_controller"
application.register("location-field", LocationFieldController)

import ItemDeactivateController from "./item_deactivate_controller"
application.register("item-deactivate", ItemDeactivateController)

// B7-B8 - Communication + Images
import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import ConversationController from "./conversation_controller"
application.register("conversation", ConversationController)

import ImagesFormController from "./images_form_controller"
application.register("images-form", ImagesFormController)

import ShareController from "./share_controller"
application.register("share", ShareController)
